import React from "react";
// toast
import { toast } from "react-toastify";

// Botão de copiar (ícone) para um valor qualquer, com aviso por toast.
export function CopyButton({ value, label }) {
  const text = value === null || value === undefined ? "" : String(value);
  if (text === "") return null;

  // copia o valor para a área de transferência e avisa o usuário
  async function copy() {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Copiado para a área de transferência");
    } catch (error) {
      toast.error("Não foi possível copiar");
    }
  }

  return (
    <button
      type="button"
      className="btn btn-link p-0"
      style={{ lineHeight: 1 }}
      title="Copiar"
      aria-label={`Copiar ${label || text}`}
      onClick={copy}
    >
      <i
        className="mdi mdi-content-copy"
        style={{ color: "grey", fontSize: 15 }}
        aria-hidden="true"
      />
    </button>
  );
}

// Exibe um valor com um botão de copiar à direita; sem valor, não renderiza nada.
// Com `href`, o valor vira link (ex.: mailto: ou WhatsApp) aberto em nova aba.
// `copyValue` permite copiar algo diferente do exibido (ex.: CPF só com dígitos).
export default function CopyValue({ value, href, copyValue }) {
  const text = value === null || value === undefined ? "" : String(value);
  const toCopy =
    copyValue === null || copyValue === undefined ? text : String(copyValue);

  if (text === "") return null;

  return (
    <span
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 8,
      }}
    >
      {href ? (
        <a href={href} target="_blank" rel="noopener noreferrer">
          {text}
        </a>
      ) : (
        <span>{text}</span>
      )}
      <CopyButton value={toCopy} label={text} />
    </span>
  );
}
